import { Box, Divider, Grid, IconButton } from "@mui/material";
import { styled } from "@mui/material/styles";
import theme from "Theme/AppTheme";
import AcxSelect from "components/UI/Select/BaseSelectComponents/AcxSelect";
import AcxSelectMulti from "components/UI/Select/BaseSelectComponents/AcxSelectMulti";
import { observer } from "mobx-react";
import React from "react";
import { Stack } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { customFilterSelectStyles } from "../../shared";

import RBCFilterStore, { IRBCFilter } from "./RBCFilterStore";
import Classifier from "models/ClassifierModel";

interface Props {
    item: IRBCFilter;
    index: number;
    store: RBCFilterStore;
    classifierOptions: Classifier[];
}

const ItemContainerGrid = styled(Grid)(({ theme }) => ({
    padding: "8px",
    backgroundColor: theme.palette.lightgray.main,
    borderRadius: "4px",
    width: "100%",
}));

const RBCFilterItem: React.FunctionComponent<Props> = observer(
    ({ item, index, store, classifierOptions }) => {
        const selectedItems = classifierOptions.filter((option) =>
            item.classifierIds.includes(option.id),
        );

        const nextItem =
            index !== store.RBCFilterItems.length - 1
                ? store.RBCFilterItems[index + 1]
                : undefined;

        const showAndOrChip =
            store.RBCFilterItems.length !== 1 &&
            index !== store.RBCFilterItems.length - 1;

        const isAnd = item.filterGroupId === nextItem?.filterGroupId;

        const selectOptions = [
            { label: "Contains", value: true },
            {
                label: "Does not contain",
                value: false,
            },
        ];

        const handleClassifierIdChange = (arg?: Classifier[]) => {
            item = {
                ...item,
                classifierIds: arg?.map((classifier) => classifier.id) ?? [],
            };
            store.setRBCFilterItem(index, item);
        };

        const renderAndOr = (
            <Grid
                container
                sx={{
                    marginTop: "12px",
                    marginBottom: "12px",
                    height: "28px",
                    position: "relative",
                }}
                justifyContent={isAnd ? "flex-start" : "center"}
                alignItems="center"
            >
                {!isAnd && (
                    <Divider
                        sx={{
                            width: "100%",
                            backgroundColor: theme.palette.lightBlue.background,
                            height: "2px",
                        }}
                    />
                )}
                <Stack
                    direction="row"
                    sx={{
                        color: "#1E40AF",
                        backgroundColor: theme.palette.lightBlue.background,
                        borderRadius: "4px",
                        padding: "5px 10px 5px 10px",
                        position: "absolute",
                        cursor: "pointer",
                    }}
                    alignItems={"center"}
                    onClick={() => {
                        store.changeRBCCombinator(index, !isAnd ? 0 : 1);
                    }}
                >
                    <Box fontWeight={"bold"}>{isAnd ? "AND" : "OR"}</Box>
                </Stack>
            </Grid>
        );

        return (
            <>
                <ItemContainerGrid>
                    <Grid
                        container
                        justifyContent="space-between"
                        alignItems="center"
                        sx={{
                            "&:hover .closeButton": {
                                visibility: "visible",
                            },
                        }}
                    >
                        <AcxSelect
                            id={"RBC-Filter-item-select-" + index}
                            options={selectOptions}
                            defaultValue={{
                                label: item.value
                                    ? "Contains"
                                    : "Does not contain",
                                value: item.value,
                            }}
                            customStyle={customFilterSelectStyles}
                            onChange={(item) => {
                                store.updateRBCItemContains(index, item.value);
                            }}
                        />
                        {index !== 0 && (
                            <IconButton
                                onClick={() => store.removeRBCFilterItem(index)}
                                size="small"
                                className="closeButton"
                                sx={{ visibility: "hidden" }}
                            >
                                <CloseIcon />
                            </IconButton>
                        )}
                    </Grid>
                    <AcxSelectMulti
                        id="application-filters-classifiers"
                        options={classifierOptions}
                        onChange={handleClassifierIdChange}
                        valueField="id"
                        labelField="name"
                        defaultValue={selectedItems}
                        containerHeight="auto"
                        maxContainerHeight="96px"
                        alignControls="flex-start"
                        isClearable={true}
                    />
                </ItemContainerGrid>
                {showAndOrChip && renderAndOr}
            </>
        );
    },
);

export default RBCFilterItem;
